import * as React from "react";
import type { SVGProps } from "react";
const SvgAvatar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path d="M9.8 2.5a4.527 4.527 0 0 1 4.533 4.506 4.53 4.53 0 0 1-1.55 3.428 7.32 7.32 0 0 1 4.333 6.68.416.416 0 0 1-.833 0 6.49 6.49 0 0 0-4.322-6.112 4.5 4.5 0 0 1-2.134.542 4.5 4.5 0 0 1-2.162-.546 6.48 6.48 0 0 0-4.332 6.115.416.416 0 0 1-.833 0 7.32 7.32 0 0 1 4.34-6.683A4.53 4.53 0 0 1 5.284 7.02 4.526 4.526 0 0 1 9.801 2.5m.003.833a3.694 3.694 0 0 0-3.687 3.688 3.7 3.7 0 0 0 5.542 3.198A3.69 3.69 0 0 0 13.5 7.01a3.69 3.69 0 0 0-3.697-3.677" />
  </svg>
);
export default SvgAvatar;
